import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { BaseService } from "./base.service";
import { AuthService } from "./auth.service";
import { IUser } from "../interfaces/ilogin";

@Injectable()
export class AppUserService extends BaseService {
    constructor(http: HttpClient, toastr: ToastrService, authService: AuthService) {
        super(http, authService, toastr);
    }

   /**
    *  Get user by email address
    */
    getUser(): Observable<IUser> {
        return super.get(`/api/ApplicationUser`);
    }
}
